import { Spin, Form, Row, Col, message, Divider, Select } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormItem,
  ErrorItem,
  ButtonItem,
  SelectItem,
  SwitchItem,
  InputNumberItem,
} from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SelectInsumosItem from "../../../../Components/SelectInsumosItem";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";

const { Option } = Select;

class VentaOnlineConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    formConCambios: false,
    ventaOnline: false,
    cotizarSinInventario: false,
    objetoProyectos: [],
    objetoPrecios: [],
    objetoVendedor: [],
    objetoBancos: [],
    objetoTiposDeClientes: [],
    todosEmbudos: [],
    objetoEmbudos: [],
    etapasOptions: [],
  };

  componentDidMount() {
    this.consultarConfiguracion();
    this.consultarDatosVentaOnline();
  }

  consultarDatosVentaOnline = () => {
    axios
      .post(
        "empresas/selectDatosVentaOnline",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((response) => {
        if (response.data.success === 2) {
          const { precios, bancos, proyectos } = response.data;

          this.setState({
            todosProyectos: proyectos || [],
            objetoProyectos: proyectos?.map((proyecto) => (
              <Option value={proyecto._id} key={proyecto._id}>
                {proyecto.nombre || proyecto.descripcion || proyecto.codigo}
              </Option>
            )),
            todosPrecios: precios || [],
            objetoPrecios: precios?.map((precio) => (
              <Option
                value={precio._id || precio.id}
                key={precio._id || precio.id}
              >
                {precio.nombre}
              </Option>
            )),
            todosBancos: bancos || [],
            objetoBancos: bancos?.map((banco) => (
              <Option value={banco._id} key={banco._id}>
                {banco.nombre}
              </Option>
            )),
          });
        } else {
          message.error("No se pudieron cargar los datos de venta online");
        }
      })
      .catch((error) => {
        message.error("Error al consultar datos de venta online");
        console.error("Error:", error);
      });

    axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("No se encontraron vendedores");
        } else {
          this.setState({
            todosVendedores: res.data,
            objetoVendedor: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    (value.apellidoMaterno || "")}
                </Option>
              );
            }),
          });
        }
      })
      .catch((error) => {
        console.error("Error al consultar vendedores:", error);
      });

    axios
      .post(
        "tiposdeclientes/selectTiposDeClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ objetoTiposDeClientes: [] });
        } else {
          this.setState({
            objetoTiposDeClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      })
      .catch((error) => {
        console.error("Error al consultar tipos de cliente:", error);
      });

    axios
      .post(
        "embudos/selectEmbudos",
        { empresaId: this.props.empresaId, estado: 1 },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const embudos = res.data.data || [];
          this.setState({
            todosEmbudos: embudos,
            objetoEmbudos: embudos.map((embudo) => (
              <Option value={embudo._id} key={embudo._id}>
                {embudo.nombreEmbudo}
              </Option>
            )),
            // La configuración pudo cargar antes que los embudos: recalcular las
            // etapas con el embudo ya seleccionado en el formulario para que el
            // select muestre el nombre y no el id.
            etapasOptions: this.getEtapasOptions(
              this.formRef.current?.getFieldValue("embudoLeadWebId"),
              embudos,
            ),
          });
        }
      })
      .catch((error) => {
        console.error("Error al consultar embudos:", error);
      });
  };

  // Calcula las opciones de etapa a partir del embudo seleccionado.
  // Acepta una lista opcional de embudos para no depender del estado aún no asentado.
  getEtapasOptions = (embudoId, embudos = this.state.todosEmbudos) => {
    const embudo = embudos.find((e) => e._id === embudoId);
    return (embudo?.etapas || []).map((etapa) => (
      <Option value={etapa._id} key={etapa._id}>
        {etapa.nombre}
      </Option>
    ));
  };

  consultarConfiguracion = () => {
    this.setState({ loading: true });

    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionVentaOnline",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data) {
          const config = res.data.data;

          const proyectosMapeados =
            config.proyectosOnline?.map((id) => ({ proyectoId: id })) || [];

          this.formRef.current.setFieldsValue({
            proyectosOnline:
              proyectosMapeados.length > 0
                ? proyectosMapeados
                : [{ proyectoId: undefined }],
            preciosOnlineId: config.preciosOnlineId,
            clienteOnlineId: config.clienteOnlineId,
            tipoClienteOnlineId: config.tipoClienteOnlineId,
            vendedorOnlineId: config.vendedorOnlineId,
            bancoOnlineId: config.bancoOnlineId,
            insumoEnvioId: config.insumoEnvioId,
            ventaOnlineSinStock: !!config.ventaOnlineSinStock,
            ventaOnlineNoApartarStock: !!config.ventaOnlineNoApartarStock,
            margenInventarioOnline: config.margenInventarioOnline ?? 100,
            cotizarSinInventario: !!config.cotizarSinInventario,
            embudoLeadWebId: config.embudoLeadWebId,
            etapaLeadWebId: config.etapaLeadWebId,
          });

          this.setState({
            cotizarSinInventario: !!config.cotizarSinInventario,
            etapasOptions: this.getEtapasOptions(config.embudoLeadWebId),
          });
        }
      })
      .catch((err) => {
        console.error("Error", err);
        message.error("Error al cargar la configuración");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  onFinish = (values) => {
    this.setState({ loading: true });

    const proyectosFormateados =
      values.proyectosOnline
        ?.map((item) => item?.proyectoId)
        ?.filter((id) => id !== undefined && id !== "") || [];

    const payload = {
      empresaId: this.props.empresaId,
      ...values,
      proyectosOnline: proyectosFormateados,
    };

    return axios
      .post(
        "/configuracionTiendaOnline/actualizarConfiguracionVentaOnline",
        payload,
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Configuración de Venta Online actualizada");
          this.setState({ formConCambios: false });
          return true;
        } else {
          message.error("No se pudo modificar la configuración");
          return false;
        }
      })
      .catch(() => message.error("Error al guardar"))
      .finally(() => this.setState({ loading: false }));
  };

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  tieneCambios = () => this.state.formConCambios;

  guardarDesdePadre = () => {
    return this.formRef.current
      .validateFields()
      .then((values) => this.onFinish(values))
      .catch(() => false);
  };

  handleValuesChange = (changedValues) => {
    if (changedValues.ventaOnline !== undefined) {
      this.setState({ ventaOnline: changedValues.ventaOnline });
      // Si se apaga, limpiar los campos
      if (!changedValues.ventaOnline) {
        this.formRef.current.setFieldsValue({
          proyectosOnline: [],
          preciosOnlineId: "",
          clienteOnlineId: "",
          tipoClienteOnlineId: "",
          vendedorOnlineId: "",
          bancoOnlineId: "",
          insumoEnvioId: "",
        });
      }
    }
    if (changedValues.cotizarSinInventario !== undefined) {
      this.setState({ cotizarSinInventario: changedValues.cotizarSinInventario });
      if (!changedValues.cotizarSinInventario) {
        this.formRef.current.setFieldsValue({
          embudoLeadWebId: undefined,
          etapaLeadWebId: undefined,
        });
        this.setState({ etapasOptions: [] });
      }
    }
    if (changedValues.embudoLeadWebId !== undefined) {
      // Al cambiar de embudo, recalcular etapas y limpiar la etapa elegida
      this.formRef.current.setFieldsValue({ etapaLeadWebId: undefined });
      this.setState({
        etapasOptions: this.getEtapasOptions(changedValues.embudoLeadWebId),
      });
    }
    if (!this.state.formConCambios) this.setState({ formConCambios: true });
  };

  descartarCambios = () => {
    this.setState({ formConCambios: false });
    this.consultarConfiguracion();
  };

  render() {
    return (
      <Spin spinning={this.state.loading}>
        <Form
          name="ventaOnlineConfig"
          layout="vertical"
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          onValuesChange={this.handleValuesChange}
          ref={this.formRef}
        >
          <DynamicCardForm
            title="Integración ERP"
            style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}
          >
            <Row gutter={24}>
              <Col span={12}>
                <div style={{ marginBottom: 24 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 8,
                      fontWeight: 500,
                    }}
                  >
                    Proyectos (Prioridad de Inventario)
                  </label>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "gray",
                      marginTop: "-6px",
                      marginBottom: "12px",
                    }}
                  >
                    Añade los proyectos en el orden de prioridad. El inventario
                    se descontará empezando por el primero de la lista.
                  </p>

                  <Form.List name="proyectosOnline">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(
                          ({ key, name, fieldKey, ...restField }, index) => (
                            <div
                              key={key}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                width: "100%",
                                marginBottom: 12,
                              }}
                            >
                              <FormItem
                                {...restField}
                                name={[name, "proyectoId"]}
                                fieldKey={[fieldKey, "proyectoId"]}
                                margin={false}
                                required
                                style={{ flex: 1, marginBottom: 0 }}
                              >
                                <SelectItem
                                  placeholder={`Prioridad ${index + 1}`}
                                  style={{ width: "100%" }}
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                              <MinusCircleOutlined
                                onClick={() => remove(name)}
                                style={{
                                  color: "red",
                                  fontSize: "16px",
                                  marginLeft: "8px",
                                }}
                              />
                            </div>
                          ),
                        )}
                        <Form.Item style={{ marginTop: "16px" }}>
                          <ButtonItem
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Añadir Proyecto a la lista
                          </ButtonItem>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                </div>
              </Col>

              <Col span={12}>
                <FormItem
                  label="Permitir venta sin stock disponible"
                  name="ventaOnlineSinStock"
                  valuePropName="checked"
                  margin
                  tooltip="Si está activo, el ecommerce permite ordenar productos aunque no haya inventario suficiente. Las ventas con faltantes se marcan en el tablero y permiten generar una requisición desde ahí."
                >
                  <SwitchItem />
                </FormItem>

                <FormItem
                  label="No apartar stock automáticamente"
                  name="ventaOnlineNoApartarStock"
                  valuePropName="checked"
                  margin
                  tooltip="Si está activo, los pedidos online ya no reservan/descuentan inventario automáticamente al crearse. El descuento real ocurrirá hasta que el pedido se entregue o embarque desde el ERP."
                >
                  <SwitchItem />
                </FormItem>

                <FormItem
                  label="Permitir cotización sin inventario"
                  name="cotizarSinInventario"
                  valuePropName="checked"
                  margin
                  tooltip="Si está activo, los productos sin inventario disponible muestran un botón 'Cotizar' (en lugar de agregar al carrito) con el precio difuminado. El cliente es enviado al formulario de contacto para solicitar la cotización."
                >
                  <SwitchItem />
                </FormItem>

                {this.state.cotizarSinInventario && (
                  <>
                    <FormItem
                      label="Embudo para leads web (cotizaciones)"
                      name="embudoLeadWebId"
                      margin
                      tooltip="Embudo del CRM donde se guardarán los leads generados por las cotizaciones. Solo aplica si el CRM está activado."
                    >
                      <SelectItem placeholder="Selecciona un embudo">
                        {this.state.objetoEmbudos}
                      </SelectItem>
                    </FormItem>

                    <FormItem
                      label="Etapa inicial del lead"
                      name="etapaLeadWebId"
                      margin
                      tooltip="Etapa del embudo en la que entrará el lead al crearse."
                    >
                      <SelectItem placeholder="Selecciona una etapa">
                        {this.state.etapasOptions}
                      </SelectItem>
                    </FormItem>
                  </>
                )}

                <FormItem
                  label="Margen de inventario mostrado (%)"
                  name="margenInventarioOnline"
                  margin
                  tooltip="Porcentaje del stock real que se muestra en la tienda. Ejemplo: 100 muestra todo, 90 muestra el 90% redondeado hacia abajo (10 piezas → 9)."
                >
                  <InputNumberItem min={1} max={100} />
                </FormItem>

                <FormItem
                  label="Cliente por defecto"
                  name="clienteOnlineId"
                  margin
                  required
                  tooltip="Cliente que será usado para mapear las ventas."
                >
                  <SelectClientesItem
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    sinBorde
                    autoFocus
                    dropdownMatchSelectWidth={600}
                    width="100%"
                    placeholder="Elija el Cliente"
                  />
                </FormItem>

                <FormItem
                  label="Tipo de Cliente por defecto"
                  name="tipoClienteOnlineId"
                  margin
                  tooltip="Será usado como tipo de cliente por defecto para los clientes que registren su cuenta en el ecommerce."
                >
                  <SelectItem placeholder="Selecciona un tipo de cliente">
                    {this.state.objetoTiposDeClientes}
                  </SelectItem>
                </FormItem>

                <FormItem
                  label="Vendedor por defecto"
                  name="vendedorOnlineId"
                  margin
                  required
                >
                  <SelectItem placeholder="Selecciona un vendedor">
                    {this.state.objetoVendedor}
                  </SelectItem>
                </FormItem>
                <FormItem
                  label="Lista de Precios"
                  name="preciosOnlineId"
                  margin
                  required
                >
                  <SelectItem placeholder="Selecciona un precio">
                    {this.state.objetoPrecios}
                  </SelectItem>
                </FormItem>

                <FormItem label="Banco" name="bancoOnlineId" margin required>
                  <SelectItem placeholder="Selecciona un banco">
                    {this.state.objetoBancos}
                  </SelectItem>
                </FormItem>
                <FormItem 
                  label="Insumo para Servicio de Envío" 
                  name="insumoEnvioId" 
                  margin 
                  required
                  tooltip="Este insumo se agregará a la venta para cobrar el costo del envío al cliente."
                >
                  <SelectInsumosItem
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    tiposInsumos="venta" 
                    placeholder="Busque y seleccione el insumo de envío"
                    style={{ width: "100%" }}
                  />
                </FormItem>
              </Col>
            </Row>
          </DynamicCardForm>

          <Divider style={{ margin: "20px 0" }} />

          <ButtonItem
            type="primary"
            htmlType="submit"
            style={{ display: "block", margin: "0 0 0 auto" }}
          >
            Guardar Configuración
          </ButtonItem>
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  VentaOnlineConfiguracion,
);
